const ISO_DURATION =
  /^P(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?)?$/i;
const SCORM_12_DURATION = /^(\d{1,4}):([0-5]\d):([0-5]\d(?:\.\d+)?)$/;

/** Convert SCORM 2004 (ISO 8601) or SCORM 1.2 session time to seconds. */
export function parseScormTimeToSeconds(value: unknown): number | null {
  if (typeof value !== 'string') return null;

  const input = value.trim();
  if (!input) return null;

  const isoMatch = ISO_DURATION.exec(input);
  if (isoMatch && isoMatch.slice(1).some((part) => part !== undefined)) {
    const [, days = '0', hours = '0', minutes = '0', seconds = '0'] = isoMatch;
    const total =
      Number(days) * 86400 +
      Number(hours) * 3600 +
      Number(minutes) * 60 +
      Number(seconds);
    return Number.isFinite(total) ? total : null;
  }

  const scorm12Match = SCORM_12_DURATION.exec(input);
  if (scorm12Match) {
    const [, hours, minutes, seconds] = scorm12Match;
    const total = Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);
    return Number.isFinite(total) ? total : null;
  }

  return null;
}

/**
 * SCORM reports cumulative time for the current session. Return only the new
 * whole seconds so repeated SetValue calls can be added without overcounting.
 * A lower value means that the SCO started a new session timer.
 */
export function getScormSessionTimeDelta(
  previousSeconds: number | undefined,
  currentSeconds: number
): number {
  const current = Math.max(0, Math.floor(currentSeconds));
  if (previousSeconds === undefined) return current;

  const previous = Math.max(0, Math.floor(previousSeconds));
  return current >= previous ? current - previous : current;
}
